var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonSvgDetailedVenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62505 3.23574C4.62505 2.40869 5.29809 1.73564 6.12515 1.73564C6.9522 1.73564 7.62524 2.40869 7.62524 3.23574V4.36081C7.62524 5.18787 6.9522 5.86091 6.12515 5.86091C5.29809 5.86091 4.62505 5.18787 4.62505 4.36081V3.23574ZM6.12515 6.61096C7.36573 6.61096 8.37529 5.60139 8.37529 4.36081V3.23574C8.37529 1.99516 7.36573 0.985596 6.12515 0.985596C5.52857 0.986257 4.95662 1.22354 4.53478 1.64538C4.11294 2.06722 3.87566 2.63917 3.875 3.23574V4.36081C3.875 5.60139 4.88457 6.61096 6.12515 6.61096Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00046 7.7356H4.25022C3.3553 7.73639 2.49726 8.09225 1.86446 8.72505C1.23165 9.35786 0.875794 10.2159 0.875 11.1108C0.875 11.2103 0.914511 11.3057 0.984842 11.376C1.05517 11.4463 1.15056 11.4858 1.25002 11.4858C1.34949 11.4858 1.44488 11.4463 1.51521 11.376C1.58554 11.3057 1.62505 11.2103 1.62505 11.1108C1.62584 10.4148 1.90268 9.74756 2.39482 9.25542C2.88696 8.76327 3.55422 8.48644 4.25022 8.48564H8.00046C8.69646 8.48644 9.36372 8.76327 9.85586 9.25542C10.348 9.74756 10.6248 10.4148 10.6256 11.1108C10.6256 11.2103 10.6651 11.3057 10.7355 11.376C10.8058 11.4463 10.9012 11.4858 11.0007 11.4858C11.1001 11.4858 11.1955 11.4463 11.2658 11.376C11.3362 11.3057 11.3757 11.2103 11.3757 11.1108C11.3749 10.2159 11.019 9.35786 10.3862 8.72505C9.75342 8.09225 8.89538 7.73639 8.00046 7.7356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonSvgDetailedVenue);
export default __webpack_public_path__ + "static/media/personSvg_detailedVenue.58aab6dc20366e7d8396935199866993.svg";
export { ForwardRef as ReactComponent };